module.exports = __webpack_public_path__ + "media/img/prices/ad-banners-ce5017671ffb2da4d4001bcf016bc328.png";